import { Helmet } from 'react-helmet-async'

const SEO = ({ 
  title = "ViralVoice - AI Assistant for Social Media Growth",
  description = "Handle thousands of DMs, automate responses, and grow your revenue with AI that speaks in your voice. Perfect for influencers, creators, and coaches.",
  image = "/og-image.jpg", // Add your OG image in public folder
  url = "https://influai.com" // Replace with your domain
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="keywords" content="AI assistant, social media automation, DM automation, influencer tools, creator economy, social media growth, AI replies" />
      <meta name="author" content="ViralVoice" />
      <meta name="theme-color" content="#000000" />

      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/logo192.png" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "ViralVoice",
          "applicationCategory": "SocialNetworkingApplication",
          "operatingSystem": "Web",
          "description": description,
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          }
        })}
      </script>
    </Helmet>
  )
}

export default SEO 